export default "__VITE_ASSET__DdVu26R9__"